exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-job-edit{width:100%!important}.user-job-edit .details-grid{background:#fff;padding:0}.user-job-edit .details-grid .k-grid-cancel,.user-job-edit .details-grid .k-grid-edit,.user-job-edit .details-grid .k-grid-update{margin:1px!important;min-width:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/app/common/Components/user-job-edit/user-job-edit.styl
 ** module id = 710
 ** module chunks = 0
 **/